import { render, staticRenderFns } from "./LinkCardHorizontal.vue?vue&type=template&id=6797e101"
import script from "./LinkCardHorizontal.vue?vue&type=script&lang=js"
export * from "./LinkCardHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports